"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathInfo = exports.getPathEmoji = exports.getPathName = void 0;
const lodash_1 = require("lodash");
const PathColors_1 = require("./PathColors");
exports.getPathName = (node) => {
    return lodash_1.get(node, ['meta', 'stepTitle'], '');
};
exports.getPathEmoji = (node) => lodash_1.get(node, ['params', 'emoji']);
exports.getPathInfo = (node) => ({
    name: exports.getPathName(node),
    color: PathColors_1.getPathColor(node),
    emoji: exports.getPathEmoji(node),
});
